import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMyAccess } from '../hooks/useMyAccess';
import { isSystemAdmin } from '../helpers/projectPermissions';
import { DOWNLOAD_LOGS_ENABLED } from '../config/featureFlags';
import { DownloadLogsView } from '../components/DownloadLogs/DownloadLogsView';

/**
 * Global, project-independent download log report. System-admin only,
 * surfaced from the sidebar nav rather than from inside a project.
 *
 * Role enforcement happens here (component-level, same posture as every
 * other gate in this codebase) — the real enforcement is the backend's
 * system-admin/internal-user role check on the global endpoints.
 */
export const AdminDownloadLogs = () => {
  const navigate = useNavigate();
  const { myAccess, loading } = useMyAccess();

  useEffect(() => {
    if (loading) return;
    if (!DOWNLOAD_LOGS_ENABLED || !isSystemAdmin(myAccess)) {
      navigate('/dashboard', { replace: true });
    }
  }, [loading, myAccess, navigate]);

  if (loading || !isSystemAdmin(myAccess)) {
    return <div className="py-12 text-center text-[#888]">Loading…</div>;
  }

  return (
    <div className="px-6 py-6">
      <h1 className="mb-4 text-lg font-semibold text-[#171717]">Document Download Log</h1>
      <DownloadLogsView scope="global" />
    </div>
  );
};
